<div class="logo">
  <a class="visible-on-sidebar-regular">
    <div class="logo-img ">
      <img style="height:50px; width: 180px;" src="/assets/img/logo.png" />
    </div>
  </a>
  <a class="visible-on-sidebar-mini">
    <div class="logo-img ">
      <img style="height:50px; " src="/assets/img/isotipo.png" />
    </div>
  </a>
</div>
<div class="sidebar-wrapper">
  <div *ngIf="isMobileMenu()">
    <form class="navbar-form">
      <span class="bmd-form-group">
        <div class="input-group no-border">
          <input type="text" value="" class="form-control" placeholder="Search...">
          <button mat-raised-button type="submit" class="btn btn-white btn-just-icon">
            <i class="material-icons">search</i>
            <div class="ripple-container"></div>
          </button>
        </div>
      </span>
    </form>
    <ul class="nav navbar-nav nav-mobile-menu">
      <li class="nav-item">
        <a class="nav-link" href="#">
          <i class="material-icons">dashboard</i>
          <p>
            <span class="d-lg-none d-md-block">Stats</span>
          </p>
        </a>
      </li>
      <li class="nav-item dropdown">
        <a class="nav-link" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
          aria-expanded="false">
          <i class="material-icons">notifications</i>
          <span class="notification">0</span>
          <p>
            <span class="d-lg-none d-md-block">Some Actions</span>
          </p>
        </a>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
        </div>
      </li>
      <li>
        <a class="dropdown-item" (click)="toggle()" routerLink="/publico/Logout">
          <i class="fa fa-sign-out fa-fw"> </i>&nbsp; Salir</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="">
          <i class="material-icons">person</i>
          <p>
            <span class="d-lg-none d-md-block">Account</span>
          </p>
        </a>
      </li>
    </ul>
  </div>
  <ul class="nav">
    <li routerLinkActive="active" *ngFor="let menuitem of menuItems" class="nav-item">
      <!--If is a single link-->
      <a [routerLink]="[menuitem.path]" *ngIf="menuitem.type === 'link'" class="nav-link">
        <i class="material-icons">{{menuitem.icontype}}</i>
        <p>{{menuitem.title}}</p>
      </a>
      <!--If it have a submenu-->
      <a data-toggle="collapse" href="#Menu{{menuitem.collapse}}" *ngIf="menuitem.type === 'sub'" (click)="updatePS()"
        class="nav-link">
        <i class="material-icons">{{menuitem.icontype}}</i>
        <p>{{menuitem.title}}<b class="caret"></b></p>
      </a>

      <!--Display the submenu items-->
      <div id="Menu{{menuitem.collapse}}" class="collapse" *ngIf="menuitem.type === 'sub'">
        <ul class="nav">
          <li routerLinkActive="active" *ngFor="let childitem of menuitem.children" class="nav-item">
            <a [routerLink]="[childitem.path]" class="nav-link" *ngIf="childitem.ab != 'XXXX'">
              <span class="sidebar-mini">{{childitem.ab}}</span>
              <span class="sidebar-normal">{{childitem.title}}</span>
            </a>
          </li>
        </ul>
      </div>
    </li>
    <li *ngIf="isAgente">
      <div class="row col-md-8 pt-3 mx-auto">
        <button class="btn btn-lg btn-mutuus-accent ng-star-inserted text-nowrap" (click)="linkReferido()">
          LINK DE REFERIDO
        </button>
      </div>
    </li>
    <li routerLinkActive="active" class="nav-item" *ngIf="idMembresia">
      <a [routerLink]="['/marketplace', idMembresia, 'catalogo']" class="nav-link">
        <i class="material-icons">shopping_bag</i>
        <p>Marketplace</p>
      </a>
    </li>
  </ul>
</div>